import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modal_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    margin: 0,
    padding: 0,
    width: "600px",
  },
  content_container: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 16px",
    backgroundColor: theme.palette.common.white,
  },
  preview_section: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "20px",
    padding: "16px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "2px dashed #ccc",
  },
  preview_image: {
    maxWidth: "100%",
    maxHeight: "300px",
    borderRadius: "8px",
    marginBottom: "12px",
    objectFit: "contain",
  },
  upload_area: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    backgroundColor: "#fafafa",
    border: "2px dashed #bdbdbd",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginBottom: "16px",

    "&:hover": {
      backgroundColor: "#f0f0f0",
      borderColor: "#9ccc65",
    },

    "&.drag-over": {
      backgroundColor: "#e8f5e9",
      borderColor: "#4caf50",
    },
  },
  upload_icon: {
    fontSize: "48px",
    color: "#9ccc65",
    marginBottom: "8px",
  },
  upload_text: {
    fontSize: "14px",
    color: "#666",
    textAlign: "center",
    marginBottom: "4px",
  },
  upload_subtext: {
    fontSize: "12px",
    color: "#999",
    textAlign: "center",
  },
  hidden_input: {
    display: "none",
  },
  description_input: {
    marginBottom: "16px",
  },
  type_form_group: {
    marginBottom: "16px",
  },
  type_label: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "8px",
  },
  type_toggle: {
    display: "flex",
    gap: "8px",
  },
  type_option: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "10px 12px",
    fontSize: "13px",
    color: "#666",
    backgroundColor: "#fafafa",
    border: "1px solid #ccc",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s ease",

    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },

    "&.active": {
      backgroundColor: "#e8f5e9",
      borderColor: "#4caf50",
      color: "#2e7d32",
      fontWeight: 600,
    },
  },
  button_container: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "16px",
    paddingTop: "16px",
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  button: {
    flex: 1,
  },
  cancel_btn: {
    flex: 1,
  },
  preview_info: {
    fontSize: "12px",
    color: "#666",
    marginTop: "8px",
    textAlign: "center",
  },
  btn: {
    padding: '8px 16px',
    backgroundColor: '#9ccc65',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  }
}));

export { useStyles };
